// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

import { createElement, Fragment, Component } from '@plesk/ui-library';
import PropTypes from 'prop-types';
import Info from './Info';
import Preferences, { OverlayAdapter } from './Preferences';
import { loadPreferences, savePreferences, hasPreferences } from './storage';

const emitter = {
    listeners: [],

    on(listener) {
        this.listeners.push(listener);
    },

    off(listener) {
        this.listeners = this.listeners.filter(l => l !== listener);
    },

    emit(flag) {
        this.listeners.forEach(listener => {
            listener(flag);
        });
    },
};

export const togglePreferences = flag => {
    emitter.emit(flag);
};

const COOKIE_POLICY_PREFERENCES_TOGGLE_SELECTOR = '[data-type="cookie-policy-preferences-toggle"]';

const subscribe = listener => {
    [...document.querySelectorAll(COOKIE_POLICY_PREFERENCES_TOGGLE_SELECTOR)].forEach(element => {
        element.addEventListener('click', listener);
    });
    emitter.on(listener);
};

const unsubscribe = listener => {
    [...document.querySelectorAll(COOKIE_POLICY_PREFERENCES_TOGGLE_SELECTOR)].forEach(element => {
        element.removeEventListener('click', listener);
    });
    emitter.off(listener);
};

class CookiePolicy extends Component {
    state = {
        isInfoVisible: !hasPreferences(),
        isPreferencesVisible: false,
    };

    componentDidMount() {
        subscribe(this.handleExternalToggle);
    }

    componentWillUnmount() {
        unsubscribe(this.handleExternalToggle);
    }

    handleSave = preferences => {
        this.setState({ isInfoVisible: false }, () => {
            const event = document.createEvent('HTMLEvents');
            event.initEvent('resize', true, false);
            document.dispatchEvent(event);
        });
        savePreferences(preferences);
        new Ajax.Request(
            Jsw.prepareUrl('/admin/gdpr/update'),
            {
                method: 'post',
                postBody: JSON.stringify(preferences),
            }
        );
    };

    handlePreferencesToggle = isPreferencesVisible => {
        this.setState({ isPreferencesVisible });
    };

    handleExternalToggle = () => {
        this.handlePreferencesToggle(true);
    };

    render() {
        const { layoutType, isInfoEnabled } = this.props;
        const { isInfoVisible, isPreferencesVisible } = this.state;
        const preferences = loadPreferences();

        return (
            <Fragment>
                {isInfoEnabled && isInfoVisible && (
                    <Info
                        onSave={this.handleSave}
                        onPreferencesToggle={this.handlePreferencesToggle}
                        contentAlignment={layoutType === 'simplified' ? 'center' : undefined}
                    />
                )}
                <Preferences
                    isOpen={isPreferencesVisible}
                    preferences={preferences}
                    onSave={this.handleSave}
                    onToggle={this.handlePreferencesToggle}
                    adapter={layoutType === 'simplified' ? OverlayAdapter : undefined}
                />
            </Fragment>
        );
    }
}

CookiePolicy.propTypes = {
    isInfoEnabled: PropTypes.bool.isRequired,
    layoutType: PropTypes.oneOf(['simplified']),
};

CookiePolicy.defaultProps = {
    layoutType: undefined,
};

export default CookiePolicy;



// WEBPACK FOOTER //
// ./app/cookie-policy/CookiePolicy.js